import React, { useRef, useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import MediaPreview from 'src/js/modules/common/components/media-preview';

function IframePreview({ url, mediaElement, iframeElement }) {
  const mediaPreviewRef = useRef(null);
  const mediaElementAspectRatioRef = useRef(
    mediaElement?.aspectRatio ? String(mediaElement.aspectRatio) : ''
  );
  const [scaledWidth, setScaledWidth] = useState(null);
  const [displayWidth, setDisplayWidth] = useState(null);

  useLayoutEffect(() => {
    if (iframeElement) {
      setScaledWidth(iframeElement.offsetWidth);
    }

    if (mediaPreviewRef.current) {
      setDisplayWidth(mediaPreviewRef.current.offsetWidth);
    }
  }, [iframeElement]);

  return (
    <MediaPreview
      ref={mediaPreviewRef}
      type="iframe"
      url={url}
      mediaAspectRatio={mediaElementAspectRatioRef.current}
      placeholderType="code"
      placeholderTitle={i18next.t('Preview is not available')}
      scaledWidth={scaledWidth}
      displayWidth={displayWidth}
    />
  );
}

IframePreview.propTypes = {
  url: PropTypes.string.isRequired,
  mediaElement: PropTypes.object.isRequired,
  iframeElement: PropTypes.object.isRequired,
};

export default IframePreview;
